import { createSlice } from '@reduxjs/toolkit';

const EXPAND_WIDTH = "280px"; // Default expanded width

const initialState = {
  expandWidth: EXPAND_WIDTH,
  mobileMenuOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setExpandWidth(state, action) {
      state.expandWidth = action.payload; // payload should be a string like '280px' or '79px'
    },
    setMobileMenuOpen(state, action) {
      state.mobileMenuOpen = action.payload;
    },
  },
});

export const { setExpandWidth, setMobileMenuOpen } = uiSlice.actions;
export default uiSlice.reducer; 